import { z } from "zod";
import { DisciplineSchema } from "../common/tunisia.js";
import { PhaseTypeSchema } from "../projects/index.js";
import { DocumentTypeSchema } from "./naming.js";
const ShortText = z.string().trim().min(1).max(40);
const DocumentMetadataSchema = z.strictObject({
  title: z.string().trim().min(1).max(300),
  discipline: DisciplineSchema.nullable(),
  phaseType: PhaseTypeSchema.nullable(),
  docType: DocumentTypeSchema.nullable(),
  zone: ShortText.nullable(),
  scale: ShortText.nullable()
});
const UploadMetadataSchema = DocumentMetadataSchema.partial();
const RevisionReasonSchema = z.string().trim().min(3).max(500);
export {
  DocumentMetadataSchema,
  RevisionReasonSchema,
  UploadMetadataSchema
};
//# sourceMappingURL=metadata.js.map